import { render, staticRenderFns } from "./VAccordion.vue?vue&type=template&id=10d36d0c&scoped=true"
import script from "./VAccordion.vue?vue&type=script&lang=js"
export * from "./VAccordion.vue?vue&type=script&lang=js"
import style0 from "./VAccordion.vue?vue&type=style&index=0&id=10d36d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d36d0c",
  null
  
)

export default component.exports